import * as core from '../../../../../../../core'
import * as policies from '../policies'

export const RESOURCE = {
  payload: {
    alias: 'policy-explorer',
    appAlias: policies.RESOURCE.payload.alias,
    description:
      'Policy areas and the policies within them, with assistant access at ' +
      'every level',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Policy Explorer',
    page: { alias: 'policies:policy-explorer' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
